import Column from '@amzn/meridian/column';
import Divider from '@amzn/meridian/divider';
import Row from '@amzn/meridian/row';
import React from 'react';

import { Profile, TeamProfile } from '../../../../Types';
import DataState from '../../../../Types/DataState';
import { weeksList } from '../../../../Util';
import ConditionalWrap from '../../../../Util/ConditionalWrap';
import UserInfoSelect from '../../../Dashboard/DashboardComponents/UserInfoSelect';
import ContainerWrapper from '../../../Dashboard/DashboardContainers/ContainerWrapper';
import Link from '@amzn/meridian/link';
import {
  Feature,
  isFeatureEnabled,
  updateSpecificFeatureFlag,
} from '../../../../config/FeaturesConfig';
import { FormattedMessage } from 'react-intl';
import Page from '../../../../Types/Page';

interface TeamProfileContainerProps {
  state: string;
  profile: TeamProfile | Profile;
  selectedWeek: string;
  setWeek: (e: React.FormEvent<HTMLSelectElement>) => void;
  isBig: boolean;
  sourcePage?: string;
}

const TeamProfileContainer: React.FC<TeamProfileContainerProps> = ({
  state,
  profile,
  selectedWeek,
  isBig,
  sourcePage,
}: TeamProfileContainerProps): React.ReactElement => {
  // NOTE - Use this equivalent restriction flag as same as ARC
  const restrictionView = isFeatureEnabled(Feature.TREND_METRICS);

  const isOM =
    profile instanceof TeamProfile
      ? profile.reportingTeam.filter(team => team.isManager === true).length > 0
      : false;

  return (
    <>
      <ContainerWrapper
        loading={state === DataState.LOADING}
        loaded={state === DataState.LOADED}
        error={state === DataState.ERROR}
      >
        <Row
          width='100%'
          widths={
            isBig
              ? ['grid-6', 'grid-3', 'grid-3']
              : ['grid-12', 'grid-12', 'grid-12']
          }
          alignmentVertical='top'
          wrap='down'
          spacing='none'
        >
          <ConditionalWrap
            condition={isBig}
            wrap={(children: any) => (
              <Column alignmentVertical='top' heights='fill'>
                {children}
              </Column>
            )}
          >
            <UserInfoSelect
              givenName={profile.user.displayName}
              username={profile.user.userName}
              weeks={weeksList()}
              selectedWeek={selectedWeek}
            />
          </ConditionalWrap>
        </Row>
        {restrictionView && isOM && sourcePage === Page.TEAM && (
          <Link
            onClick={() => {
              updateSpecificFeatureFlag(Feature.ASSOCIATE_RICH_CARDS, true);
              window.location.reload();
            }}
            type='secondary'
          >
            <FormattedMessage
              id='cs_perfportal_arc_back_to_arc'
              defaultMessage='Back to New Team Page'
            />
          </Link>
        )}
      </ContainerWrapper>

      <Row width='100%' spacingInset='400 none' spacing='none'>
        <Divider size='small' />
      </Row>
    </>
  );
};

export default TeamProfileContainer;
